// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/plan_auto_resubmit_setting_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { ProcurementPlanAutoResubmitCategory } from "../../bfftypes/v1/procurement_plan_auto_resubmit_category_pb";
import { file_bfftypes_v1_procurement_plan_auto_resubmit_category } from "../../bfftypes/v1/procurement_plan_auto_resubmit_category_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/plan_auto_resubmit_setting_model.proto.
 */
export const file_bffuser_v1_plan_auto_resubmit_setting_model: GenFile = /*@__PURE__*/
  fileDesc("CjFiZmZ1c2VyL3YxL3BsYW5fYXV0b19yZXN1Ym1pdF9zZXR0aW5nX21vZGVsLnByb3RvEgpiZmZ1c2VyLnYxIucBCiJQcm9jdXJlbWVudFBsYW5BdXRvUmVzdWJtaXRTZXR0aW5nEigKCWFyZWFfY29kZRgBIAEoDjIVLmJmZnR5cGVzLnYxLkFyZWFDb2RlEkIKCGNhdGVnb3J5GAIgASgOMjAuYmZmdHlwZXMudjEuUHJvY3VyZW1lbnRQbGFuQXV0b1Jlc3VibWl0Q2F0ZWdvcnkSDwoHZW5hYmxlZBgDIAEoCBIzCgp1cGRhdGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBQg0KC191cGRhdGVkX2F0QkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bfftypes_v1_area, file_bfftypes_v1_procurement_plan_auto_resubmit_category, file_google_protobuf_timestamp]);

/**
 * ProcurementPlanAutoResubmitSetting is the automatic-resubmission on/off of
 * one 需要調達計画 setting unit (area × 区分, plan-auto-resubmit.md
 * AC-PAR-001).
 *
 * @generated from message bffuser.v1.ProcurementPlanAutoResubmitSetting
 */
export type ProcurementPlanAutoResubmitSetting = Message<"bffuser.v1.ProcurementPlanAutoResubmitSetting"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.ProcurementPlanAutoResubmitCategory category = 2;
   */
  category: ProcurementPlanAutoResubmitCategory;

  /**
   * False for a unit that has never been saved (既定はオフ).
   *
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * Optimistic-lock token: the persisted updated_at of the unit. Absent when
   * the unit has never been saved.
   *
   * @generated from field: optional google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.ProcurementPlanAutoResubmitSetting.
 * Use `create(ProcurementPlanAutoResubmitSettingSchema)` to create a new message.
 */
export const ProcurementPlanAutoResubmitSettingSchema: GenMessage<ProcurementPlanAutoResubmitSetting> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_plan_auto_resubmit_setting_model, 0);

